import React, { useState, useEffect } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { format } from "date-fns";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Toolbar } from "primereact/toolbar";
import { InputText } from "primereact/inputtext";
import { exportExcel } from "../hooks/useExportUtils";
import  AlumnoDialog  from "./AlumnoDialog";
import  FacturacionDialog  from "./FacturacionDialog";
import { MultiSelect } from 'primereact/multiselect';

export const ListadoEmpleados = () => {
  const [visible, setVisible] = useState(false);
  const [visibleFact, setVisibleFact] = useState(false);
  const [matricula, setMatricula] = useState(null);
  const [alumnoSeleccionado, setAlumnoSeleccionado] = useState(null);
  const [alumnos, setAlumnos] = useState([]);
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(50);
  const [globalFilter, setGlobalFilter] = useState("");  
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const verAlumno = (rowData) => {
    setAlumnoSeleccionado(rowData);
    setVisible(true);
  };
  

useEffect(() => {
  const getData = async () => {
    try {
      const response = await axiosPrivate.get("CEUM/alumnos/listado/" );        
      const data = response.data;
      setAlumnos(data);
    } catch (error) {
      console.error("Error al obtener empleados:", error);
    }
  };
  getData();
}, []);

const multiSelectFilterTemplate = (options, listOptions) => {
  return (
    <MultiSelect
      value={options.value}
      options={listOptions}
      onChange={(e) => options.filterApplyCallback(e.value)}
      placeholder="Selecciona"
      className="p-column-filter"
      maxSelectedLabels={1}
      style={{ maxWidth: '10rem' }}
    />
  );
};
const [filters, setFilters] = useState({
  Grado: { value: null, matchMode: 'in' },
  Grupo: { value: null, matchMode: 'in' }
});
const gradosOptions = [...new Set(alumnos.map(e => e.Grado))]
  .map(g => ({ label: g, value: g }));
const gruposOptions = [...new Set(alumnos.map(e => e.Grupo))]
  .map(g => ({ label: g, value: g }));
  const columns = [
    { field: "Matricula", header: "Matricula" , sortable: true},
    { field: "Nombres", header: "Nombre", sortable: true },
    { field: "Apellido_paterno", header: "Apellido Paterno", sortable: true },
    { field: "Apellido_materno", header: "Apellido Materno", sortable: true },
    { field: "CURP", header: "CURP" , sortable: true},
    {
    field: "Grado",
    header: "Grado",
    sortable: true,
    filter: true,
    filterElement: (options) => multiSelectFilterTemplate(options, gradosOptions)
  },

  {
    field: "Grupo",
    header: "Grupo",
    sortable: true,
    filter: true,
    filterElement: (options) => multiSelectFilterTemplate(options, gruposOptions)
  }
    // { field: "Acciones", header: "Acciones", sortable: true },
  ];

  const dynamicColumns = columns.map((col) => (
    <Column key={col.field} field={col.field} header={col.header} 
    sortable={col.sortable} 
    filter={col.filter} 
    filterElement={col.filterElement}
    />
  ));

  const template2 = {
    layout: "RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink",
    RowsPerPageDropdown: (options) => {
      const dropdownOptions = [
        { label: 10, value: 10 },
        { label: 20, value: 20 },
        { label: 50, value: 50 },
      ];

      return (
        <>
          <span className="mx-2">Items por página:</span>
          <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
        </>
      );
    },
    CurrentPageReport: (options) => (
      <span className="mx-2">
        {options.first} - {options.last} de {options.totalRecords}
      </span>
    )
  };

  const onCustomPage2 = (event) => {
    setFirst2(event.first);
    setRows2(event.rows);
  };
 const handleBack = () => {
    navigate(-1);
  };
 const leftToolbarTemplate = () => (
    <div className="flex gap-2 items-center flex-center">      
      <Button
        label="Exportar Excel"
        icon="pi pi-file-excel"
        severity="success"
        onClick={() => exportExcel(alumnos, "Alumnos")}
      />
    </div>
  );

  const rightToolbarTemplate = () => (
    <span className="p-input-icon-left">
      <i className="pi pi-search" />
      <InputText
        type="search"
        placeholder="Buscar..."
        value={globalFilter}
        onChange={(e) => setGlobalFilter(e.target.value)}
        className=" ml-4"
      />
    </span>
  );
const actionBodyTemplate = (rowData) => {
  return (
    <div className="flex gap-2">
      <Button
      label="Datos facturacion"
        icon="pi pi-receipt"
        className="p-button-sm p-button-primary"
        onClick={() => abrirFacturacion(rowData)}
      />
      <Button    
      label="Ver"
      icon="pi pi-eye"
      className="p-button-sm p-button-primary"
      onClick={() => verAlumno(rowData)}
    />
    </div>
  );
  
};
const abrirFacturacion = (rowData) => {
  setMatricula(rowData.Matricula);
  setVisibleFact(true);
};
  return (
    <div className="p-m-4">
      <AlumnoDialog
        visible={visible}
        setVisible={setVisible}
        alumno={alumnoSeleccionado}
      />
      <FacturacionDialog
        visible={visibleFact}
        setVisible={setVisibleFact}
        matricula={matricula}
      />
      <Card title="Alumnos">
        <div className="mb-3 flex justify-content-between">
                    <Button label="Regresar" icon="pi pi-arrow-left" className="p-button-secondary" onClick={handleBack} />
          </div>
      <Toolbar
          className="mb-4"
          left={leftToolbarTemplate}
          right={rightToolbarTemplate}
        />                  
        <DataTable
          value={alumnos}
          responsiveLayout="scroll"
          paginator
          paginatorTemplate={template2}
          first={first2}
          rows={rows2}
          onPage={onCustomPage2}
          removableSort
          globalFilter={globalFilter} 
          className="p-datatable-sm"
          stripedRows
          filters={filters}
          filterDisplay="row"
        >         
          {dynamicColumns} 
          <Column
            header="Acciones"
            body={actionBodyTemplate}
            style={{ minWidth: '120px' }}
          />
        </DataTable>
      </Card>
    </div>
  );
};

export default ListadoEmpleados;
